export default import.meta.ROLLDOWN_FILE_URL_9wy3_79WtdabJRDFTj$4lw